/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { InstanceBulkDecisionRequestBidirectionalActionDetails } from './InstanceBulkDecisionRequestBidirectionalActionDetails';
import {
    InstanceBulkDecisionRequestBidirectionalActionDetailsFromJSON,
    InstanceBulkDecisionRequestBidirectionalActionDetailsFromJSONTyped,
    InstanceBulkDecisionRequestBidirectionalActionDetailsToJSON,
} from './InstanceBulkDecisionRequestBidirectionalActionDetails';

/**
 * 
 * @export
 * @interface InstanceBulkDecisionRequest
 */
export interface InstanceBulkDecisionRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InstanceBulkDecisionRequest
     */
    lead_ids: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InstanceBulkDecisionRequest
     */
    status_id: string;
    /**
     * 
     * @type {InstanceBulkDecisionRequestBidirectionalActionDetails}
     * @memberof InstanceBulkDecisionRequest
     */
    bidirectional_action_details?: InstanceBulkDecisionRequestBidirectionalActionDetails;
}

/**
 * Check if a given object implements the InstanceBulkDecisionRequest interface.
 */
export function instanceOfInstanceBulkDecisionRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lead_ids" in value;
    isInstance = isInstance && "status_id" in value;

    return isInstance;
}

export function InstanceBulkDecisionRequestFromJSON(json: any): InstanceBulkDecisionRequest {
    return InstanceBulkDecisionRequestFromJSONTyped(json, false);
}

export function InstanceBulkDecisionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstanceBulkDecisionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lead_ids': json['lead_ids'],
        'status_id': json['status_id'],
        'bidirectional_action_details': !exists(json, 'bidirectional_action_details') ? undefined : InstanceBulkDecisionRequestBidirectionalActionDetailsFromJSON(json['bidirectional_action_details']),
    };
}

export function InstanceBulkDecisionRequestToJSON(value?: InstanceBulkDecisionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lead_ids': value.lead_ids,
        'status_id': value.status_id,
        'bidirectional_action_details': InstanceBulkDecisionRequestBidirectionalActionDetailsToJSON(value.bidirectional_action_details),
    };
}

